<ng-container *ngIf="matchScore">
  <div class="match-details is-print-mode">
    <div class="match-details__header">
      <round-progress [score]="matchScore.totalMatch"></round-progress>
      <div class="match-details__header__mid">
        <h1>{{ 'MatchDetails.HeaderTitle' | translate }}</h1>
        <div>
          {{ 'MatchDetails.HeaderDescription' | translate }}
        </div>
      </div>
    </div>

    <div class="match-details__section is-print-section">
      <div class="match-details__section__header">
        <h2>{{ (isVacancy ? 'MatchDetails.TabVacancy' : 'MatchDetails.TabTalent') | translate }}</h2>
      </div>
      <vacancy-talent-info *ngIf="additionalData" [enableScroll]="false" [isVacancy]="isVacancy"
        [data]="additionalData">
      </vacancy-talent-info>
    </div>

    <div class="match-details__section is-print-section">
      <div class="match-details__section__header">
        <round-progress [small]="true" [score]="matchScore.hardSkillsMatch"></round-progress>
        <div class="match-details__header__mids">
          <h2>{{ 'MatchDetails.HardSkillsTitle' | translate }}</h2>
          <div>
            {{ 'MatchDetails.HardSkillsDescription' | translate }}
          </div>
        </div>
      </div>

      <div class="match-details__table a-section" *ngIf="hardSkillsCommon">
        <h4>{{ 'MatchDetails.CommonSkills' | translate }}</h4>
        <div class="match-details__table__inner-wrapper">
          <div class="match-details__table__inner">
            <div class="match-details__table__item is-header is-three-cols">
              <div>{{ 'MatchDetails.VacancySkills' | translate }}</div>
              <div>{{ 'MatchDetails.TalentSkills' | translate }}</div>
              <div>{{ 'MatchDetails.VacancyExpYears' | translate }}</div>
              <div>{{ 'MatchDetails.TalentExpYears' | translate }}</div>
              <div>{{ 'MatchDetails.ExpertiseRequired' | translate }}</div>
              <div>{{ 'MatchDetails.TalentExpertise' | translate }}</div>
              <div>{{ 'MatchDetails.Matching' | translate }}</div>
            </div>
            <ng-container *ngFor="let branch of hardSkillsCommon">
              <div class="match-details__table__item is-three-cols" *ngFor="let skill of branch.skills">
                <div class="skill-col">
                  <span *ngIf="leastFoundSkills?.includes(skill.name)" class="exclamation-sign"
                    title="Less than 5% of candidates has this skill matching requirements">!</span>
                  {{ skill.name }}
                </div>
                <div>{{ skill.skillMatch ? skill.name : '-' }}</div>
                <div>{{ skill.vacancyExp }}</div>
                <div>{{ skill.talentExp }}</div>
                <div>{{ skill.expertiseRequired }}</div>
                <div>{{ skill.talentExpertise }}</div>
                <div>{{ skill.skillMatch.toFixed() }} %</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="match-details__table a-section" *ngIf="hardSkillsSimilar">
        <h4>{{ 'MatchDetails.SimilarSkills' | translate }}</h4>
        <div class="match-details__table__inner-wrapper">
          <div class="match-details__table__inner">
            <div class="match-details__table__item is-header is-three-cols">
              <div>{{ 'MatchDetails.VacancySkills' | translate }}</div>
              <div>{{ 'MatchDetails.TalentSkills' | translate }}</div>
              <div>{{ 'MatchDetails.VacancyExpYears' | translate }}</div>
              <div>{{ 'MatchDetails.TalentExpYears' | translate }}</div>
              <div>{{ 'MatchDetails.ExpertiseRequired' | translate }}</div>
              <div>{{ 'MatchDetails.TalentExpertise' | translate }}</div>
              <div>{{ 'MatchDetails.Matching' | translate }}</div>
            </div>
            <ng-container *ngFor="let branch of hardSkillsSimilar">
              <div class="match-details__table__item is-three-cols" *ngFor="let skill of branch.skills">
                <div>{{ skill.name }}</div>
                <div>{{ skill.closeSkillName }}</div>
                <div>{{ skill.vacancyExp }}</div>
                <div>{{ skill.talentExp }}</div>
                <div>{{ skill.expertiseRequired }}</div>
                <div>{{ skill.talentExpertise }}</div>
                <div>{{ skill.skillMatch.toFixed() }} %</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="match-details__section is-print-section">
      <div class="match-details__section__header">
        <h2>{{ 'MatchDetails.ExpectationsTitle' | translate }}</h2>
      </div>
      <div style="position: relative;">
        <vacancy-talent-details [matchDetails]="matchDetails"></vacancy-talent-details>
      </div>
    </div>
  </div>
</ng-container>
